<template>
  <div class="toasts-container">
    <transition-group name="slide-down" tag="div" class="d-flex flex-column">
      <div
        :class="'toast-item text-center toast-' + toast.type.toLowerCase()"
        v-for="toast in toasts"
        :key="toast.id"
      >
        {{ toast.message }}
      </div>
    </transition-group>
  </div>
</template>

<script>
/**
 * This is a toast component that can be used to show generic messages, errors
 * It listens to the store (where toasts data is present and renders the messages as toast)
 * Toast can be of following type
 *  - SUCCESS
 *  - ERROR
 *  - WARNING
 *
 * Toast will auto-dismiss after 3000ms
 */
import * as R from 'ramda'
import EventBus from '@/EventBus'
import { TOAST_TYPE } from '@/constants/toasts'

export default {
  name: 'Toast',
  data() {
    return { dismissAfter: 3000, toasts: [], id: 1 }
  },
  mounted() {
    EventBus.$on('ADD_TOAST', payload => {
      const { message, type = TOAST_TYPE.SUCCESS, dismissAfter } = payload
      let toast = { message, type, id: this.id++, dismissAfter }
      this.toasts = [toast, ...this.toasts]
    })
  },
  watch: {
    toasts(current, prev) {
      const newToasts = R.differenceWith((x, y) => x.id === y.id, current, prev)
      newToasts.forEach(toast => {
        setTimeout(() => {
          this.toasts = this.toasts.filter(x => x.id !== toast.id)
        }, toast.dismissAfter || this.dismissAfter)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/animations/slideDown';
@import '~@/styles/_styleConfigurations.scss';

.toasts-container {
  position: fixed;
  right: 0;
  left: 0;
  top: 10px;
  overflow: visible;
  padding: 0 30px;
  font-size: 0.875rem;
  z-index: 1050;
}
.toast-item {
  min-width: 300px;
  display: inline-block;
  border-radius: 16px;
  padding: 3px 10px;
  align-self: center;
  &:not(:last-child) {
    margin-bottom: 12px;
  }
}
.toast-error {
  background-color: $error;
  color: white;
}
.toast-success {
  background-color: $activeSecondary;
  color: white;
}
</style>
